import { render, staticRenderFns } from "./SpecificNewsPage.vue?vue&type=template&id=4afa060f&scoped=true&"
import script from "./SpecificNewsPage.vue?vue&type=script&lang=js&"
export * from "./SpecificNewsPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificNewsPage.vue?vue&type=style&index=0&id=4afa060f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa060f",
  null
  
)

export default component.exports